import { formatMoney } from '@theme/money-formatting';

(function () {
  function initNewHeader(root) {
    var scope = root || document;
    var headers = scope.querySelectorAll('[data-new-header]:not([data-new-header-ready])');

    headers.forEach(function (header) {
      header.setAttribute('data-new-header-ready', 'true');
      var isHomePage = header.dataset.isHome === 'true';

      var pageWrapper = document.querySelector('.page-wrapper');
      var menuButton = header.querySelector('.new-header__menu-button');
      var drawer = header.querySelector('.new-header-drawer');
      var overlay = header.querySelector('.new-header-drawer__overlay');
      var closeButton = header.querySelector('.new-header-drawer__close');
      var navTriggers = header.querySelectorAll('.new-header__nav-trigger');
      var cartCount = header.querySelector('[data-new-header-cart-count]');
      var cartDropdown = header.querySelector('[data-new-header-cart-dropdown]');
      var cartItems = header.querySelector('[data-new-header-cart-items]');
      var cartSubtotal = header.querySelector('[data-new-header-cart-subtotal]');
      var cartFooter = header.querySelector('[data-new-header-cart-footer]');
      var cartWrap = header.querySelector('.new-header__cart-wrap');
      var CART_LINES_UPDATE_EVENT = 'shopify:cart:lines-update';
      var PAGE_CACHE_MAX_AGE = 10000;
      var CART_FETCH_COOLDOWN = 5000;
      var lastCartFetchAt = 0;
      var productImageFallbackCache = {};

      function escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      // Mirrors the money filter Liquid uses to render this same dropdown, so
      // prices keep the store's separators instead of switching to the
      // browser-locale ones as soon as the cart updates over AJAX.
      function formatCartMoney(amountInMinorUnits, currency) {
        var amount = Number(amountInMinorUnits) || 0;
        var format = ((typeof Theme !== 'undefined' && Theme.moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');

        return formatMoney(amount, format, currency || 'USD');
      }

      function normalizeImageUrl(rawUrl) {
        if (!rawUrl || typeof rawUrl !== 'string') return '';

        var normalizedUrl = rawUrl.indexOf('//') === 0 ? window.location.protocol + rawUrl : rawUrl;
        if (normalizedUrl.indexOf('width=') !== -1) return normalizedUrl;

        return normalizedUrl + (normalizedUrl.indexOf('?') === -1 ? '?width=180' : '&width=180');
      }

      function resolveCartItemImage(item) {
        var rawImageField = item ? item.image : null;
        var featuredImage = item && item.featured_image ? item.featured_image : null;
        var rawUrl =
          (typeof rawImageField === 'string' && rawImageField) ||
          (rawImageField && typeof rawImageField.url === 'string' && rawImageField.url) ||
          (rawImageField && typeof rawImageField.src === 'string' && rawImageField.src) ||
          (featuredImage && typeof featuredImage.url === 'string' && featuredImage.url) ||
          (featuredImage && typeof featuredImage.src === 'string' && featuredImage.src) ||
          (item && typeof item.product_image === 'string' && item.product_image) ||
          (item && item.product && typeof item.product.featured_image === 'string' && item.product.featured_image) ||
          (item && item.product && item.product.featured_image && typeof item.product.featured_image.url === 'string' && item.product.featured_image.url) ||
          '';

        return normalizeImageUrl(rawUrl);
      }

      function resolveImageFromProductResponse(product, variantId) {
        if (!product) return '';

        var normalizedVariantId = String(variantId || '');
        var variantImageUrl = '';

        if (normalizedVariantId && Array.isArray(product.variants)) {
          var variant = product.variants.find(function (entry) {
            return String(entry && entry.id) === normalizedVariantId;
          });

          if (variant) {
            if (typeof variant.featured_image === 'string') {
              variantImageUrl = variant.featured_image;
            } else if (variant.featured_image && typeof variant.featured_image.src === 'string') {
              variantImageUrl = variant.featured_image.src;
            } else if (variant.featured_image && typeof variant.featured_image.url === 'string') {
              variantImageUrl = variant.featured_image.url;
            }
          }
        }

        return normalizeImageUrl(
          variantImageUrl ||
            (typeof product.featured_image === 'string' && product.featured_image) ||
            (Array.isArray(product.images) && product.images[0]) ||
            ''
        );
      }

      function fetchProductImageByHandle(handle, variantId) {
        var normalizedHandle = String(handle || '').trim();
        if (!normalizedHandle) return Promise.resolve('');

        var cacheKey = normalizedHandle + '::' + String(variantId || '');
        if (productImageFallbackCache[cacheKey]) return productImageFallbackCache[cacheKey];

        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var encodedHandle = encodeURIComponent(normalizedHandle).replace(/%2F/g, '/');
        var request = fetch(rootUrl + 'products/' + encodedHandle + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Failed to fetch product payload');
            return response.json();
          })
          .then(function (product) {
            return resolveImageFromProductResponse(product, variantId);
          })
          .catch(function () {
            return '';
          });

        productImageFallbackCache[cacheKey] = request;
        return request;
      }

      function setCartFooterVisible(isVisible) {
        if (cartFooter) cartFooter.classList.toggle('is-hidden', !isVisible);
      }

      function renderCartDropdown(cart) {
        if (!cartItems) return;

        var items = cart && Array.isArray(cart.items) ? cart.items : [];
        var currency = cart && cart.currency ? cart.currency : 'USD';

        if (!items.length) {
          cartItems.innerHTML = '<p class="new-header__cart-empty">Your cart is empty.</p>';
          if (cartSubtotal) cartSubtotal.textContent = formatCartMoney(0, currency);
          setCartFooterVisible(false);
          return;
        }

        return Promise.all(
          items.map(function (item) {
            var productUrl = escapeHtml(item.url || '#');
            var productTitle = escapeHtml(item.product_title || item.title || 'Product');
            var imageAlt = escapeHtml(
              (item.featured_image && item.featured_image.alt) || item.product_title || item.title || ''
            );
            var price = formatCartMoney(item.final_line_price || item.line_price || 0, currency);
            var quantity = Number(item.quantity) || 0;
            var initialImageUrl = resolveCartItemImage(item);

            return (initialImageUrl ? Promise.resolve(initialImageUrl) : fetchProductImageByHandle(item.handle, item.variant_id)).then(
              function (resolvedImageUrl) {
                var imageHtml = resolvedImageUrl
                  ? '<img src="' + escapeHtml(resolvedImageUrl) + '" alt="' + imageAlt + '" loading="lazy" width="76" height="76">'
                  : '<span class="new-header__cart-row-image-placeholder" aria-hidden="true">No image</span>';

                return (
                  '<div class="new-header__cart-row">' +
                  '<a class="new-header__cart-row-image" href="' +
                  productUrl +
                  '">' +
                  imageHtml +
                  '</a>' +
                  '<div class="new-header__cart-row-content">' +
                  '<a class="new-header__cart-row-title" href="' +
                  productUrl +
                  '">' +
                  productTitle +
                  '</a>' +
                  '<div class="new-header__cart-row-meta">' +
                  '<span>' +
                  escapeHtml(price) +
                  '</span>' +
                  '<span>Quantity: ' +
                  quantity +
                  '</span>' +
                  '</div>' +
                  '</div>' +
                  '</div>'
                );
              }
            );
          })
        ).then(function (rowsHtml) {
          cartItems.innerHTML = rowsHtml.join('');
          if (cartSubtotal) cartSubtotal.textContent = formatCartMoney(cart.total_price || 0, currency);
          setCartFooterVisible(true);
        });
      }

      function setCartCount(value) {
        if (!cartCount) return;

        var count = Number.isFinite(value) ? Math.max(0, value) : 0;
        var visibleCount = count > 99 ? '99+' : String(count);

        cartCount.textContent = visibleCount;
        cartCount.classList.toggle('is-hidden', count === 0);
      }

      function parseSessionCount() {
        var sessionStorageCount = sessionStorage.getItem('cart-count');
        if (!sessionStorageCount) return null;

        try {
          var parsed = JSON.parse(sessionStorageCount);
          if (Date.now() - parsed.timestamp > PAGE_CACHE_MAX_AGE) return null;

          var parsedValue = parseInt(parsed.value, 10);
          return Number.isNaN(parsedValue) ? null : parsedValue;
        } catch (_error) {
          return null;
        }
      }

      function refreshCartStateFromApi(force) {
        if (!force && Date.now() - lastCartFetchAt < CART_FETCH_COOLDOWN) {
          return Promise.resolve();
        }

        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        return fetch(rootUrl + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Failed to fetch cart count');
            return response.json();
          })
          .then(function (cart) {
            lastCartFetchAt = Date.now();
            setCartCount(cart?.item_count || 0);
            return renderCartDropdown(cart);
          })
          .catch(function () {
            // no-op: keep current rendered value if request fails
          });
      }

      // The event payload already carries the updated cart, so paint from it
      // instead of waiting on another /cart.js round trip: that extra request
      // left the dropdown showing the pre-add state for about a second, long
      // enough for a shopper to hover right after adding and see a stale cart.
      function renderCartStateFromEvent(result) {
        var items = result && result.detail && Array.isArray(result.detail.items) ? result.detail.items : null;
        if (!items) return false;

        var cart = result.cart || {};
        var totalAmount = cart.cost && cart.cost.totalAmount;
        var currency = (totalAmount && totalAmount.currencyCode) || 'USD';
        // The event reports the total in major units ("1743.95"), while the
        // dropdown works in minor units like /cart.js does. Deriving the scale
        // from the decimals Shopify sent keeps zero- and three-decimal
        // currencies correct without carrying a currency table here.
        var amountText = String((totalAmount && totalAmount.amount) || '0');
        var minorUnitMultiplier = Math.pow(10, (amountText.split('.')[1] || '').length);
        var amount = Number(amountText) || 0;
        var itemCount = cart.totalQuantity;

        if (!Number.isFinite(itemCount)) {
          itemCount = items.reduce(function (total, item) {
            return total + (Number(item.quantity) || 0);
          }, 0);
        }

        lastCartFetchAt = Date.now();
        setCartCount(itemCount);
        renderCartDropdown({
          items: items,
          currency: currency,
          total_price: Math.round(amount * minorUnitMultiplier),
        });

        return true;
      }

      function onCartLinesUpdate(event) {
        event.promise
          ?.then(function (result) {
            if (!renderCartStateFromEvent(result)) refreshCartStateFromApi(true);
          })
          .catch(function () {
            // no-op: ignore rejected cart update promises
          });
      }

      function onPageShow(event) {
        if (!event.persisted) return;

        var countFromSession = parseSessionCount();
        if (countFromSession !== null) {
          setCartCount(countFromSession);
        }

        refreshCartStateFromApi(true);
      }

      function onCartHover() {
        refreshCartStateFromApi();
      }

      function openCartDropdown() {
        if (!cartWrap || !cartDropdown) return;
        cartWrap.classList.add('is-open');
        onCartHover();
      }

      function closeCartDropdown() {
        if (!cartWrap) return;
        cartWrap.classList.remove('is-open');
      }

      function getScrollTop() {
        return Math.max(
          window.scrollY || 0,
          document.documentElement.scrollTop || 0,
          document.body.scrollTop || 0,
          pageWrapper ? pageWrapper.scrollTop : 0
        );
      }

      function updateHeaderState() {
        var shouldUseScrolledState = !isHomePage || getScrollTop() > 50;
        header.classList.toggle('is-scrolled', shouldUseScrolledState);
      }

      function playEntryAnimation() {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            header.classList.add('is-entered');
          });
        });
      }

      function closeDesktopMenus(exceptItem) {
        navTriggers.forEach(function (trigger) {
          var item = trigger.closest('.new-header__nav-item');
          if (item !== exceptItem) {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      }

      function openDrawer() {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        menuButton.setAttribute('aria-expanded', 'true');
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        menuButton.setAttribute('aria-expanded', 'false');
      }

      function setDrawerGroupHeight(group, shouldOpen) {
        if (!group) return;

        var content = group.querySelector('[data-drawer-group-content]');
        var toggle = group.querySelector('.new-header-drawer__group-toggle');
        if (!content || !toggle) return;

        var currentHeight = content.offsetHeight;
        var targetHeight = shouldOpen ? content.scrollHeight : 0;

        content.style.height = currentHeight + 'px';

        requestAnimationFrame(function () {
          group.classList.toggle('is-open', shouldOpen);
          toggle.setAttribute('aria-expanded', String(shouldOpen));
          content.style.height = targetHeight + 'px';
        });

        var onEnd = function (event) {
          if (event.propertyName !== 'height') return;
          if (shouldOpen) {
            content.style.height = 'auto';
          }
          content.removeEventListener('transitionend', onEnd);
        };

        content.addEventListener('transitionend', onEnd);
      }

      function initDrawerGroups() {
        var groups = drawer ? drawer.querySelectorAll('[data-drawer-group]') : [];
        if (!groups.length) return;

        groups.forEach(function (group) {
          var toggle = group.querySelector('.new-header-drawer__group-toggle');
          var content = group.querySelector('[data-drawer-group-content]');
          if (!toggle || !content) return;

          content.style.height = group.classList.contains('is-open') ? 'auto' : '0px';
          toggle.setAttribute('aria-expanded', String(group.classList.contains('is-open')));

          toggle.addEventListener('click', function () {
            var isOpen = group.classList.contains('is-open');
            setDrawerGroupHeight(group, !isOpen);
          });
        });

        window.addEventListener('resize', function () {
          groups.forEach(function (group) {
            var content = group.querySelector('[data-drawer-group-content]');
            if (!content || !group.classList.contains('is-open')) return;
            if (content.style.height !== 'auto') return;
            content.style.height = 'auto';
          });
        });
      }

      navTriggers.forEach(function (trigger) {
        var item = trigger.closest('.new-header__nav-item');
        if (!item) return;

        trigger.addEventListener('mouseenter', function () {
          closeDesktopMenus(item);
          item.classList.add('is-open');
        });

        trigger.addEventListener('focus', function () {
          closeDesktopMenus(item);
          item.classList.add('is-open');
        });

        item.addEventListener('mouseleave', function () {
          item.classList.remove('is-open');
        });

        item.addEventListener('focusout', function (event) {
          if (!item.contains(event.relatedTarget)) {
            item.classList.remove('is-open');
          }
        });
      });

      document.addEventListener('click', function (event) {
        if (!event.target.closest('.new-header__nav')) closeDesktopMenus();
        if (cartWrap && !event.target.closest('.new-header__cart-wrap')) closeCartDropdown();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeDesktopMenus();
          closeCartDropdown();
          closeDrawer();
        }
      });

      menuButton.addEventListener('click', openDrawer);
      overlay.addEventListener('click', closeDrawer);
      closeButton.addEventListener('click', closeDrawer);
      initDrawerGroups();
      if (cartWrap && cartDropdown) {
        cartWrap.addEventListener('mouseenter', openCartDropdown);
        cartWrap.addEventListener('mouseleave', closeCartDropdown);
        cartWrap.addEventListener('focusin', openCartDropdown);
        cartWrap.addEventListener('focusout', function (event) {
          if (!cartWrap.contains(event.relatedTarget)) closeCartDropdown();
        });
      }
      document.addEventListener(CART_LINES_UPDATE_EVENT, onCartLinesUpdate);
      window.addEventListener('pageshow', onPageShow);
      window.addEventListener('scroll', updateHeaderState, { passive: true });
      if (pageWrapper) pageWrapper.addEventListener('scroll', updateHeaderState, { passive: true });

      var initialSessionCount = parseSessionCount();
      if (initialSessionCount !== null) {
        setCartCount(initialSessionCount);
      }
      refreshCartStateFromApi(true);

      playEntryAnimation();
      updateHeaderState();
    });
  }

  window.newHeaderInit = initNewHeader;

  document.addEventListener('shopify:section:load', function (event) {
    initNewHeader(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initNewHeader(document);
    });
  } else {
    initNewHeader(document);
  }
})();
